import { Tooltip as T } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { surface } from "./foundation";
export const Tooltip = T.Root;
export const TooltipTrigger = T.Trigger;
export function TooltipProvider(props: ComponentProps<typeof T.Provider>) {
  return <T.Provider delayDuration={400} {...props} />;
}
export function TooltipContent({
  className,
  sideOffset = 6,
  ...props
}: ComponentProps<typeof T.Content>) {
  return (
    <T.Portal>
      <T.Content {...props} sideOffset={sideOffset} className={cn("cyra-tooltip", className)} />
    </T.Portal>
  );
}
